import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getProductPath(locale: Locale, productSlug: string): string {
	const pathMap = sameValueForEveryLocale(`/${productSlug}`);

	return getPathInLocale(locale, pathMap);
}
